export default __webpack_public_path__ + "static/media/Download.99add352.svg";